/**
 * Christmas Lucky Wheel JS
 * Author: Shopify Developer
 * Version: 2.2.0
 * Fixed email submission and added background image features
 */

(function() {
  'use strict';
  
  // 配置
  const CONFIG = window.EV_APP_CONFIG || {
    dailyDrawLimit: 1,
    extraSpinsFromShare: 1,
    couponDuration: 1 * 60 * 60 * 1000,
    rewards: [],
    texts: {}
  };
  
  // 缓存DOM节点
  const DOM = {
    container: document.getElementById('ev-christmas-wheel'),
    recordsContainer: document.getElementById('ev-records-container'),
    noPrizes: document.getElementById('ev-no-prizes'),
    winnersScroll: document.getElementById('ev-winners-scroll'),
    wheelImage: document.getElementById('ev-wheel-image'),
    spinsLeft: document.getElementById('ev-spins-left'),
    spinButton: document.getElementById('ev-spin-button'),
    wheelResult: document.getElementById('ev-wheel-result'),
    resultPrize: document.getElementById('ev-result-prize'),
    // 弹窗
    emailPopup: document.getElementById('ev-email-popup'),
    emailOverlay: document.getElementById('ev-email-overlay'),
    emailInput: document.getElementById('ev-email-input'),
    emailSubmit: document.getElementById('ev-email-submit'),
    emailMessage: document.getElementById('ev-email-message'),
    emailClose: document.getElementById('ev-email-close'),
    emailForm: document.getElementById('ev-email-form'),
    prizePopup: document.getElementById('ev-prize-popup'),
    prizeOverlay: document.getElementById('ev-prize-overlay'),
    prizeContent: document.getElementById('ev-prize-content'),
    prizeClose: document.getElementById('ev-prize-close'),
    successPopup: document.getElementById('ev-success-popup'),
    successOverlay: document.getElementById('ev-success-overlay'),
    successContent: document.getElementById('ev-success-content'),
    successClose: document.getElementById('ev-success-close'),
    sharePopup: document.getElementById('ev-share-popup'),
    shareOverlay: document.getElementById('ev-share-overlay'),
    shareClose: document.getElementById('ev-share-close'),
    shareMessage: document.getElementById('ev-share-message'),
    // 社交媒体按钮
    facebookShare: document.getElementById('ev-facebook-share'),
    twitterShare: document.getElementById('ev-twitter-share'),
    whatsappShare: document.getElementById('ev-whatsapp-share'),
    instagramShare: document.getElementById('ev-instagram-share'),
    shareFb: document.getElementById('ev-share-fb'),
    shareTwitter: document.getElementById('ev-share-twitter'),
    shareWhatsapp: document.getElementById('ev-share-whatsapp'),
    shareInstagram: document.getElementById('ev-share-instagram'),
    shareTitle: document.querySelector('.ev-share-title')
  };
  
  // 状态管理
  let state = {
    isSpinning: false,
    isSubmitting: false,
    shareWindow: null,
    countdownTimer: null
  };
  
  // 工具函数：节流
  function throttle(fn, delay) {
    let timer = null;
    return function(...args) {
      if (!timer) {
        fn.apply(this, args);
        timer = setTimeout(() => {
          timer = null;
        }, delay);
      }
    };
  }
  
  // 工具函数：防抖
  function debounce(fn, delay) {
    let timer = null;
    return function(...args) {
      clearTimeout(timer);
      timer = setTimeout(() => {
        fn.apply(this, args);
      }, delay);
    };
  }
  
  // 工具函数：安全DOM操作
  const DOMUtils = {
    setText: function(el, text) {
      if (el && el.textContent !== undefined) {
        el.textContent = text;
      }
    },
    setHTML: function(el, html) {
      if (el && el.innerHTML !== undefined) {
        el.innerHTML = html;
      }
    },
    addClass: function(el, className) {
      if (el && el.classList) {
        el.classList.add(className);
      }
    },
    removeClass: function(el, className) {
      if (el && el.classList) {
        el.classList.remove(className);
      }
    },
    toggleClass: function(el, className, condition) {
      if (el && el.classList) {
        if (condition) {
          el.classList.add(className);
        } else {
          el.classList.remove(className);
        }
      }
    },
    show: function(el) {
      if (el) {
        el.style.display = 'block';
      }
    },
    hide: function(el) {
      if (el) {
        el.style.display = 'none';
      }
    },
    isVisible: function(el) {
      return el && el.style.display !== 'none';
    }
  };
  
  // 数据存储
  const Storage = {
    key: 'evChristmasWheelData',
    allUsersKey: 'evChristmasWheelAllUsers',
    
    getUserId: function() {
      let userId = localStorage.getItem('evChristmasWheelUserId');
      if (!userId) {
        // 兼容性UUID生成
        userId = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
          const r = Math.random() * 16 | 0;
          const v = c === 'x' ? r : (r & 0x3 | 0x8);
          return v.toString(16);
        });
        localStorage.setItem('evChristmasWheelUserId', userId);
      }
      return userId;
    },
    
    getUserData: function() {
      const now = Date.now();
      const userId = this.getUserId();
      const allData = JSON.parse(localStorage.getItem(this.allUsersKey)) || {};
      let userData = allData[userId] || {
        subscribed: false,
        lastDrawDate: null,
        drawsToday: 0,
        extraSpins: 0,
        drawnRewards: [],
        email: null,
        hasShared: false
      };
      
      // 检查是否是新的一天
      if (userData.lastDrawDate) {
        const d = new Date(userData.lastDrawDate);
        const today = new Date();
        if (d.getDate() !== today.getDate() || d.getMonth() !== today.getMonth() || d.getFullYear() !== today.getFullYear()) {
          userData.drawsToday = 0;
          userData.hasShared = false;
          userData.extraSpins = 0;
        }
      }
      
      // 过滤过期的奖励
      userData.drawnRewards = userData.drawnRewards.filter(r => r.expiresAt > now);
      
      return userData;
    },
    
    saveUserData: function(data) {
      const userId = this.getUserId();
      const allData = JSON.parse(localStorage.getItem(this.allUsersKey)) || {};
      allData[userId] = data;
      localStorage.setItem(this.allUsersKey, JSON.stringify(allData));
    },
    
    clearExpiredData: function() {
      const now = Date.now();
      const allData = JSON.parse(localStorage.getItem(this.allUsersKey)) || {};
      
      Object.keys(allData).forEach(userId => {
        const userData = allData[userId];
        userData.drawnRewards = userData.drawnRewards.filter(r => r.expiresAt > now);
        allData[userId] = userData;
      });
      
      localStorage.setItem(this.allUsersKey, JSON.stringify(allData));
    }
  };
  
  // 消息系统
  const Message = {
    show: function(message, type = 'info', duration = 3000) {
      const colors = {
        error: '#d90429',
        success: '#2E8B57',
        info: '#2E8B57',
        warning: '#ff9800'
      };
      
      const notification = document.createElement('div');
      notification.textContent = message;
      
      notification.style.cssText = `
        position: fixed;
        top: 20px;
        left: 50%;
        transform: translateX(-50%) translateY(-20px);
        background: white;
        color: ${colors[type]};
        padding: 12px 20px;
        border-radius: 6px;
        font-size: 14px;
        z-index: 10001;
        opacity: 0;
        transition: opacity 0.3s, transform 0.3s;
        border: 2px solid ${colors[type]};
        box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
        pointer-events: none;
        max-width: 80%;
        text-align: center;
        font-weight: 600;
      `;
      
      document.body.appendChild(notification);
      
      // 触发重绘
      notification.offsetHeight;
      
      notification.style.opacity = '1';
      notification.style.transform = 'translateX(-50%) translateY(0)';
      
      setTimeout(() => {
        notification.style.opacity = '0';
        notification.style.transform = 'translateX(-50%) translateY(-20px)';
        
        setTimeout(() => {
          if (notification.parentNode) {
            notification.parentNode.removeChild(notification);
          }
        }, 300);
      }, duration);
    },
    
    showError: function(message) {
      this.show(message, 'error');
    },
    
    showSuccess: function(message) {
      this.show(message, 'success');
    },
    
    showInfo: function(message) {
      this.show(message, 'info');
    }
  };
  
  // 弹窗系统
  const Popup = {
    open: function(popup, overlay) {
      if (popup && overlay) {
        DOMUtils.addClass(overlay, 'show');
        DOMUtils.addClass(popup, 'show');
        document.body.style.overflow = 'hidden';
      }
    },
    
    close: function(popup, overlay) {
      if (popup && overlay) {
        DOMUtils.removeClass(popup, 'show');
        DOMUtils.removeClass(overlay, 'show');
        document.body.style.overflow = '';
      }
    },
    
    closeAll: function() {
      const popups = [
        { popup: DOM.emailPopup, overlay: DOM.emailOverlay },
        { popup: DOM.prizePopup, overlay: DOM.prizeOverlay },
        { popup: DOM.successPopup, overlay: DOM.successOverlay },
        { popup: DOM.sharePopup, overlay: DOM.shareOverlay }
      ];
      
      popups.forEach(({ popup, overlay }) => {
        if (popup && overlay) {
          DOMUtils.removeClass(popup, 'show');
          DOMUtils.removeClass(overlay, 'show');
        }
      });
      
      document.body.style.overflow = '';
    },
    
    bindCloseEvents: function() {
      // 点击遮罩层关闭弹窗
      const overlays = [
        DOM.emailOverlay,
        DOM.prizeOverlay,
        DOM.successOverlay,
        DOM.shareOverlay
      ];
      
      overlays.forEach(overlay => {
        if (overlay) {
          overlay.addEventListener('click', () => {
            Popup.closeAll();
          });
        }
      });
      
      // 点击关闭按钮
      const closeButtons = [
        { btn: DOM.emailClose, popup: DOM.emailPopup, overlay: DOM.emailOverlay },
        { btn: DOM.prizeClose, popup: DOM.prizePopup, overlay: DOM.prizeOverlay },
        { btn: DOM.successClose, popup: DOM.successPopup, overlay: DOM.successOverlay },
        { btn: DOM.shareClose, popup: DOM.sharePopup, overlay: DOM.shareOverlay }
      ];
      
      closeButtons.forEach(({ btn, popup, overlay }) => {
        if (btn) {
          btn.addEventListener('click', (e) => {
            e.stopPropagation();
            Popup.close(popup, overlay);
          });
        }
      });
    }
  };
  
  // 转盘系统
  const Wheel = {
    prizesCount: 8,
    
    spin: function(reward, onComplete) {
      if (!DOM.wheelImage || state.isSpinning) return;
      
      state.isSpinning = true;
      DOMUtils.hide(DOM.wheelResult);
      
      // 移除之前的动画类
      DOMUtils.removeClass(DOM.wheelImage, 'ev-wheel-spinning');
      
      // 强制重绘
      DOM.wheelImage.offsetHeight;
      
      // 添加旋转动画类
      DOMUtils.addClass(DOM.wheelImage, 'ev-wheel-spinning');
      
      // 动画结束
      setTimeout(() => {
        state.isSpinning = false;
        
        if (onComplete && typeof onComplete === 'function') {
          onComplete();
        }
      }, 6000);
    },
    
    showResult: function(reward) {
      if (!DOM.wheelResult || !DOM.resultPrize) return;
      
      let prizeText = '';
      if (reward.type === 'product') {
        prizeText = `🎁 FREE ${reward.title}`;
      } else {
        prizeText = `$${reward.discount} OFF`;
      }
      
      DOMUtils.setText(DOM.resultPrize, prizeText);
      DOMUtils.addClass(DOM.wheelResult, 'show');
      DOMUtils.show(DOM.wheelResult);
    },
    
    drawRandomReward: function() {
      const totalWeight = CONFIG.rewards.reduce((sum, reward) => sum + (reward.weight || 0), 0);
      const random = Math.random() * totalWeight;
      
      let currentWeight = 0;
      for (const reward of CONFIG.rewards) {
        currentWeight += (reward.weight || 0);
        if (random < currentWeight) {
          return reward;
        }
      }
      
      return CONFIG.rewards[0];
    }
  };
  
  // 奖品管理
  const PrizeManager = {
    addReward: function(reward, saveToStorage = true) {
      const now = Date.now();
      const expiresAt = reward.expiresAt || (now + CONFIG.couponDuration);
      
      // 创建DOM片段
      const fragment = document.createDocumentFragment();
      const div = document.createElement('div');
      div.className = 'ev-coupon';
      div.dataset.expiresAt = expiresAt;
      div.dataset.rewardId = reward.code || reward.variantId;
      
      const diff = Math.max(0, expiresAt - now);
      const hours = Math.floor(diff / (1000 * 60 * 60));
      const mins = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const secs = Math.floor((diff % (1000 * 60)) / 1000);
      const initialTime = `${String(hours).padStart(2, '0')}:${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
      
      if (reward.type === 'product') {
        div.innerHTML = `
          <div class="ev-coupon-main">
            <img src="${reward.image}" alt="${reward.title}" class="ev-product-image" loading="lazy">
            <div class="ev-product-info">
              <div class="ev-product-title">${reward.title}</div>
              <div class="ev-product-price">🎁 FREE</div>
              <div class="ev-coupon-timer"><span class="ev-expires-text">Expires in</span> <span class="ev-countdown">${initialTime}</span></div>
            </div>
          </div>
          <button class="ev-use-button" data-variant="${reward.variantId}">Add to Cart</button>`;
      } else {
        div.innerHTML = `
          <div class="ev-coupon-main">
            <div class="ev-coupon-discount">$${reward.discount}</div>
            <div>
              <div class="ev-coupon-expiry">Spend $${reward.threshold}</div>
              <div class="ev-coupon-timer"><span class="ev-expires-text">Expires in</span> <span class="ev-countdown">${initialTime}</span></div>
            </div>
          </div>
          <button class="ev-use-button" data-code="${reward.code}">Use Now</button>`;
      }
      
      fragment.appendChild(div);
      
      // 添加到容器
      if (DOM.recordsContainer && DOM.noPrizes) {
        if (DOMUtils.isVisible(DOM.noPrizes)) {
          DOMUtils.hide(DOM.noPrizes);
        }
        DOM.recordsContainer.insertBefore(fragment, DOM.recordsContainer.firstChild);
        
        // 启动倒计时
        this.startCountdown(div.querySelector('.ev-countdown'), expiresAt, div);
      }
      
      // 保存到存储
      if (saveToStorage) {
        const userData = Storage.getUserData();
        userData.drawnRewards.unshift({
          ...reward,
          createdAt: now,
          expiresAt: expiresAt
        });
        Storage.saveUserData(userData);
      }
    },
    
    loadRewards: function() {
      const userData = Storage.getUserData();
      
      if (!DOM.recordsContainer || !DOM.noPrizes) return;
      
      // 清空容器
      DOM.recordsContainer.innerHTML = '';
      
      if (userData.drawnRewards.length === 0) {
        DOMUtils.show(DOM.noPrizes);
        return;
      }
      
      DOMUtils.hide(DOM.noPrizes);
      
      // 批量创建DOM片段
      const fragment = document.createDocumentFragment();
      const now = Date.now();
      
      userData.drawnRewards
        .sort((a, b) => b.createdAt - a.createdAt)
        .forEach(reward => {
          const div = document.createElement('div');
          div.className = 'ev-coupon';
          
          const expiresAt = reward.expiresAt;
          const diff = Math.max(0, expiresAt - now);
          const hours = Math.floor(diff / (1000 * 60 * 60));
          const mins = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
          const secs = Math.floor((diff % (1000 * 60)) / 1000);
          const initialTime = `${String(hours).padStart(2, '0')}:${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
          
          if (reward.type === 'product') {
            div.innerHTML = `
              <div class="ev-coupon-main">
                <img src="${reward.image}" alt="${reward.title}" class="ev-product-image" loading="lazy">
                <div class="ev-product-info">
                  <div class="ev-product-title">${reward.title}</div>
                  <div class="ev-product-price">🎁 FREE</div>
                  <div class="ev-coupon-timer"><span class="ev-expires-text">Expires in</span> <span class="ev-countdown">${initialTime}</span></div>
                </div>
              </div>
              <button class="ev-use-button" data-variant="${reward.variantId}">Add to Cart</button>`;
          } else {
            div.innerHTML = `
              <div class="ev-coupon-main">
                <div class="ev-coupon-discount">$${reward.discount}</div>
                <div>
                  <div class="ev-coupon-expiry">Spend $${reward.threshold}</div>
                  <div class="ev-coupon-timer"><span class="ev-expires-text">Expires in</span> <span class="ev-countdown">${initialTime}</span></div>
                </div>
              </div>
              <button class="ev-use-button" data-code="${reward.code}">Use Now</button>`;
          }
          
          div.dataset.expiresAt = expiresAt;
          fragment.appendChild(div);
        });
      
      DOM.recordsContainer.appendChild(fragment);
      
      // 为所有元素启动倒计时
      document.querySelectorAll('.ev-coupon').forEach(coupon => {
        const countdownEl = coupon.querySelector('.ev-countdown');
        const expiresAt = parseInt(coupon.dataset.expiresAt, 10);
        if (countdownEl && expiresAt) {
          this.startCountdown(countdownEl, expiresAt, coupon);
        }
      });
    },
    
    startCountdown: function(el, expiresAt, card) {
      if (!el) return;
      
      const update = throttle(() => {
        const now = Date.now();
        const left = expiresAt - now;
        
        if (left <= 0) {
          DOMUtils.setText(el, 'Expired');
          if (card) card.style.opacity = '0.6';
          
          setTimeout(() => {
            if (card && card.parentNode) {
              card.remove();
              const userData = Storage.getUserData();
              userData.drawnRewards = userData.drawnRewards.filter(r => r.expiresAt > now);
              Storage.saveUserData(userData);
              
              // 如果没有奖品了，显示提示
              if (document.querySelectorAll('.ev-coupon').length === 0 && DOM.noPrizes) {
                DOMUtils.show(DOM.noPrizes);
              }
            }
          }, 2000);
          return;
        }
        
        const hours = Math.floor(left / (1000 * 60 * 60));
        const mins = Math.floor((left % (1000 * 60 * 60)) / (1000 * 60));
        const secs = Math.floor((left % (1000 * 60)) / 1000);
        
        DOMUtils.setText(el, `${String(hours).padStart(2, '0')}:${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`);
        
        setTimeout(update, 1000);
      }, 1000);
      
      update();
    }
  };
  
  // 抽奖逻辑 - 修复后的版本
  const SpinManager = {
    checkPermission: function(userData) {
      if (!userData.subscribed) {
        return { valid: false, reason: 'not_subscribed' };
      }
      
      const totalDrawsLeft = (CONFIG.dailyDrawLimit + userData.extraSpins) - userData.drawsToday;
      if (totalDrawsLeft <= 0) {
        return { valid: false, reason: 'no_spins' };
      }
      
      return { valid: true };
    },
    
    handleSpin: function() {
      if (state.isSpinning || !DOM.spinButton) return;
      
      const userData = Storage.getUserData();
      const permission = this.checkPermission(userData);
      
      if (!permission.valid) {
        if (permission.reason === 'not_subscribed') {
          Popup.open(DOM.emailPopup, DOM.emailOverlay);
        } else if (permission.reason === 'no_spins') {
          Message.showInfo('You have used all your spins today. Come back tomorrow!');
        }
        return;
      }
      
      // 禁用按钮
      DOM.spinButton.disabled = true;
      DOMUtils.setText(DOM.spinButton, 'Spinning...');
      
      // 抽奖
      const reward = Wheel.drawRandomReward();
      
      // 转盘动画
      Wheel.spin(reward, () => {
        // 处理结果
        this.handleSpinResult(reward, userData);
        
        // 恢复按钮
        setTimeout(() => {
          DOM.spinButton.disabled = false;
          DOMUtils.setText(DOM.spinButton, CONFIG.texts.spinButton || 'SPIN');
        }, 1000);
      });
    },
    
    handleSpinResult: function(reward, userData) {
      const now = Date.now();
      
      // 更新用户数据
      userData.drawsToday++;
      userData.lastDrawDate = now;
      
      Storage.saveUserData(userData);
      UI.updateSpinsLeft();
      
      // 显示结果
      Wheel.showResult(reward);
      PrizeManager.addReward(reward, true);
      
      // 显示中奖弹窗
      this.showPrizePopup(reward);
      
      // 更新UI
      UI.update();
      
      // 埋点
      Analytics.track('spin_completed', { 
        prizeType: reward.type,
        prizeValue: reward.type === 'product' ? reward.title : `$${reward.discount}`
      });
    },
    
    showPrizePopup: function(reward) {
      if (!DOM.prizePopup || !DOM.prizeContent) return;
      
      let message = '';
      if (reward.type === 'product') {
        message = `Congratulations! You won a FREE ${reward.title}!`;
      } else {
        message = `Congratulations! You won $${reward.discount} OFF!`;
      }
      
      DOMUtils.setText(DOM.prizeContent, message);
      Popup.open(DOM.prizePopup, DOM.prizeOverlay);
    }
  };
  
  // 邮箱订阅 - 修复AJAX提交
  const EmailManager = {
    validateEmail: function(email) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    },
    
    handleSubmit: function(e) {
      e.preventDefault();
      
      if (state.isSubmitting || !DOM.emailInput || !DOM.emailSubmit) return;
      
      const email = DOM.emailInput.value.trim();
      
      if (!email) {
        DOMUtils.setText(DOM.emailMessage, 'Please enter your email address.');
        return;
      }
      
      if (!this.validateEmail(email)) {
        DOMUtils.setText(DOM.emailMessage, 'Please enter a valid email address.');
        return;
      }
      
      state.isSubmitting = true;
      DOM.emailSubmit.disabled = true;
      DOMUtils.setText(DOM.emailSubmit, 'Subscribing...');
      
      // 使用AJAX提交到Shopify
      const formData = {
        'form_type': 'customer',
        'utf8': '✓',
        'contact[email]': email,
        'contact[tags]': 'newsletter,Lucky Wheel Subscriber',
        'contact[accepts_marketing]': true
      };
      
      // 使用AJAX POST请求
      fetch('/contact', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/json'
        },
        body: new URLSearchParams(formData)
      })
      .then(response => {
        if (response.ok) {
          return response.json ? response.json() : response.text();
        }
        throw new Error('Network response was not ok.');
      })
      .then(data => {
        // 保存用户数据
        const userData = Storage.getUserData();
        userData.subscribed = true;
        userData.email = email;
        userData.drawsToday = 0; // 重置当天抽奖次数
        userData.extraSpins = 0;
        userData.lastDrawDate = Date.now();
        Storage.saveUserData(userData);
        
        // 关闭弹窗
        Popup.close(DOM.emailPopup, DOM.emailOverlay);
        
        // 显示成功消息
        this.showSuccessMessage();
        
        // 更新UI
        UI.update();
        UI.updateSpinsLeft();
        
        // 重置表单
        this.resetForm();
        
        // 埋点
        Analytics.track('email_subscribed', { email: email });
      })
      .catch(error => {
        console.error('Subscription error:', error);
        // 即使请求失败，我们也更新本地状态（离线支持）
        const userData = Storage.getUserData();
        userData.subscribed = true;
        userData.email = email;
        userData.drawsToday = 0;
        userData.extraSpins = 0;
        Storage.saveUserData(userData);
        
        Popup.close(DOM.emailPopup, DOM.emailOverlay);
        UI.update();
        UI.updateSpinsLeft();
        this.showSuccessMessage();
        this.resetForm();
        
        Analytics.track('email_subscribed', { email: email });
      })
      .finally(() => {
        state.isSubmitting = false;
      });
    },
    
    showSuccessMessage: function() {
      if (!DOM.successContent) return;
      
      DOMUtils.setText(DOM.successContent, 'Thank you for subscribing! You got 1 free spin today!');
      Popup.open(DOM.successPopup, DOM.successOverlay);
      
      // 3秒后自动关闭
      setTimeout(() => {
        Popup.close(DOM.successPopup, DOM.successOverlay);
      }, 3000);
    },
    
    resetForm: function() {
      if (DOM.emailInput) DOM.emailInput.value = '';
      if (DOM.emailMessage) DOMUtils.setText(DOM.emailMessage, '');
      if (DOM.emailSubmit) {
        DOM.emailSubmit.disabled = false;
        DOMUtils.setText(DOM.emailSubmit, CONFIG.texts.subscribe_button_text || 'Subscribe & Spin');
      }
    }
  };
  
  // 分享系统
  const ShareManager = {
    platforms: {
      facebook: {
        name: 'Facebook',
        color: '#1877F2',
        getUrl: function(text, url) {
          return `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}&quote=${encodeURIComponent(text)}`;
        }
      },
      twitter: {
        name: 'Twitter',
        color: '#1DA1F2',
        getUrl: function(text, url) {
          return `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(url)}`;
        }
      },
      whatsapp: {
        name: 'WhatsApp',
        color: '#25D366',
        getUrl: function(text, url) {
          return `https://wa.me/?text=${encodeURIComponent(text + ' ' + url)}`;
        }
      },
      instagram: {
        name: 'Instagram',
        color: '#E1306C',
        getUrl: function(text, url) {
          return 'https://www.instagram.com/';
        }
      }
    },
    
    isRewarding: false,
    
    handleShare: function(platform) {
      const userData = Storage.getUserData();
      
      // 1. 检查是否已经分享过
      if (userData.hasShared) {
        Message.showInfo('You have already earned extra spin today! Come back tomorrow!');
        return;
      }
      
      // 2. 检查是否正在奖励，防止重复触发
      if (this.isRewarding) {
        Message.showInfo('Processing your reward... Please wait!');
        return;
      }
      
      const shareText = 'Spin the Christmas Lucky Wheel and win amazing prizes! ';
      const shareUrl = window.location.href;
      const platformConfig = this.platforms[platform];
      
      if (!platformConfig) return;
      
      // 3. 标记为正在奖励（加锁）
      this.isRewarding = true;
      
      if (platform === 'instagram') {
        // Instagram特殊处理：复制链接
        this.copyToClipboard(shareUrl, platformConfig.name);
        // 复制成功后奖励（只奖励一次）
        setTimeout(() => {
          this.rewardUser();
          this.isRewarding = false;
        }, 500);
      } else {
        // 其他平台：打开分享窗口
        const shareWindow = window.open(
          platformConfig.getUrl(shareText, shareUrl),
          'shareWindow',
          'width=600,height=400,scrollbars=yes'
        );
        
        // 监听窗口关闭（只奖励一次）
        if (shareWindow) {
          let hasRewarded = false; // 标记是否已奖励
          const checkClosed = setInterval(() => {
            if (shareWindow.closed && !hasRewarded) {
              clearInterval(checkClosed);
              this.rewardUser();
              hasRewarded = true;
              this.isRewarding = false;
            }
          }, 1000);
          
          // 5秒后超时（只奖励一次）
          setTimeout(() => {
            clearInterval(checkClosed);
            if (!hasRewarded) {
              this.rewardUser();
              hasRewarded = true;
              this.isRewarding = false;
            }
          }, 5000);
        } else {
          // 窗口打开失败，仍奖励一次
          this.rewardUser();
          this.isRewarding = false;
        }
      }
      
      // 关闭分享弹窗
      Popup.close(DOM.sharePopup, DOM.shareOverlay);
    },
    
    copyToClipboard: function(text, platformName) {
      navigator.clipboard.writeText(text).then(() => {
        Message.showSuccess(`Link copied! Share on ${platformName} to get extra spin!`);
      }).catch(() => {
        // 降级方案
        const textArea = document.createElement('textarea');
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.select();
        
        try {
          document.execCommand('copy');
          Message.showSuccess(`Link copied! Share on ${platformName} to get extra spin!`);
        } catch (err) {
          Message.showError('Failed to copy link. Please copy it manually: ' + text);
        }
        
        document.body.removeChild(textArea);
      });
    },
    
    rewardUser: function() {
      const userData = Storage.getUserData();
      
      // 双重保险：再次检查是否已分享
      if (userData.hasShared) return;
      
      userData.hasShared = true;
      userData.extraSpins += CONFIG.extraSpinsFromShare;
      Storage.saveUserData(userData);
      UI.updateSpinsLeft();
      
      // 更新UI
      UI.update();
      
      // 显示成功消息
      Message.showSuccess(`🎉 Thanks for sharing! +${CONFIG.extraSpinsFromShare} extra spin!`);
      
      // 埋点
      Analytics.track('share_completed', { 
        extraSpins: CONFIG.extraSpinsFromShare 
      });
    }
  };
  
  // 购物车系统
  const CartManager = {
    handleAddToCart: function(variantId, button) {
      if (!variantId || !button) return;
      
      button.disabled = true;
      DOMUtils.setText(button, 'Adding...');
      
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');
      
      fetch('/cart/add', {
        method: 'POST',
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then(data => {
        Message.showSuccess('🎁 Product added to cart!');
        DOMUtils.setText(button, 'Added');
        
        // 埋点
        Analytics.track('product_added_to_cart', { variantId: variantId });
      })
      .catch(error => {
        console.error('Add to cart error:', error);
        Message.showError('Failed to add product. Please try again later.');
        button.disabled = false;
        DOMUtils.setText(button, 'Add to Cart');
      });
    },
    
    handleDiscountCode: function(code, button) {
      if (!code || !button) return;
      
      button.disabled = true;
      DOMUtils.setText(button, 'Applying...');
      
      // 复制到剪贴板
      navigator.clipboard.writeText(code).then(() => {
        Message.showSuccess(`Discount code "${code}" copied!`);
        DOMUtils.setText(button, 'Copied');
        
        // 可选：自动应用到购物车
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ discount: code })
        }).catch(() => {
          // 静默失败
        });
        
        // 重置按钮
        setTimeout(() => {
          button.disabled = false;
          DOMUtils.setText(button, 'Use Now');
        }, 2000);
        
        // 埋点
        Analytics.track('discount_code_copied', { code: code });
      })
      .catch(() => {
        // 降级方案
        Message.showInfo(`Please copy this code: ${code}`);
        button.disabled = false;
        DOMUtils.setText(button, 'Use Now');
      });
    }
  };
  
  // 最近获奖者
  const WinnersManager = {
    possiblePrizes: [
      '5% Discount', '10% Discount', '20% Discount', '30% Discount', 
      '$150 Discount', '$30 Discount', '$5 Discount', '$20 Discount',
      'FREE Keychain', 'FREE Hat'
    ],
    
    init: function() {
      if (!DOM.winnersScroll) return;
      
      // 生成随机获奖者
      const winners = this.generateWinners(15); // 生成15个获奖者
      const allWinners = [...winners, ...winners]; // 复制一份用于无缝滚动
      
      // 使用文档片段批量创建DOM
      const fragment = document.createDocumentFragment();
      
      allWinners.forEach(winner => {
        const div = document.createElement('div');
        div.className = 'ev-winning-item';
        div.innerHTML = `
          <span class="ev-winner-name">${winner.name}</span> won <span class="ev-winner-prize">${winner.prize}</span>
        `;
        fragment.appendChild(div);
      });
      
      DOM.winnersScroll.innerHTML = '';
      DOM.winnersScroll.appendChild(fragment);
      
      // 重置动画
      DOM.winnersScroll.style.animation = 'none';
      setTimeout(() => {
        DOM.winnersScroll.style.animation = 'scrollWinners 60s linear infinite';
      }, 10);
    },
    
    generateWinners: function(count) {
      const firstName = ['Alex', 'Jordan', 'Taylor', 'Casey', 'Morgan', 'Riley', 'Avery', 'Drew', 'Blake', 'Cameron'];
      const lastName = ['Smith', 'Johnson', 'Williams', 'Brown', 'Jones', 'Garcia', 'Miller', 'Davis', 'Rodriguez', 'Martinez'];
      
      const winners = [];
      for (let i = 0; i < count; i++) {
        const first = firstName[Math.floor(Math.random() * firstName.length)];
        const last = lastName[Math.floor(Math.random() * lastName.length)];
        const prize = this.possiblePrizes[Math.floor(Math.random() * this.possiblePrizes.length)];
        
        winners.push({
          name: `${first.charAt(0)}${'*'.repeat(3)}${last.charAt(0)}`,
          prize: prize
        });
      }
      
      return winners;
    }
  };
  
  // 分析系统
  const Analytics = {
    track: function(eventName, data = {}) {
      const eventData = {
        event: eventName,
        timestamp: Date.now(),
        userId: Storage.getUserId(),
        ...data
      };
      
      // 本地存储事件（可后续上报到服务器）
      const events = JSON.parse(localStorage.getItem('evChristmasWheelEvents')) || [];
      events.push(eventData);
      localStorage.setItem('evChristmasWheelEvents', JSON.stringify(events.slice(-100))); // 只保留最近100个事件
      
      // 可选：发送到服务器
      // this.sendToServer(eventData);
    },
    
    sendToServer: function(data) {
      // 这里可以添加发送到服务器的逻辑
      // fetch('/api/track', {
      //   method: 'POST',
      //   headers: { 'Content-Type': 'application/json' },
      //   body: JSON.stringify(data)
      // });
    }
  };
  
  // UI更新
  const UI = {
    update: function() {
      this.updateSpinButton();
      this.updateShareButtons();
      this.updateSpinsLeft();
    },
    
    updateSpinButton: function() {
      if (!DOM.spinButton) return;
      
      const userData = Storage.getUserData();
      const totalDrawsLeft = (CONFIG.dailyDrawLimit + userData.extraSpins) - userData.drawsToday;
      
      if (!userData.subscribed) {
        DOMUtils.setText(DOM.spinButton, CONFIG.texts.getFreeSpin || 'Get free spin chance today');
        DOM.spinButton.disabled = false;
      } else if (totalDrawsLeft > 0) {
        DOMUtils.setText(DOM.spinButton, CONFIG.texts.spinButton || 'SPIN');
        DOM.spinButton.disabled = false;
      } else {
        DOMUtils.setText(DOM.spinButton, CONFIG.texts.comeBackTomorrow || 'Come Back Tomorrow');
        DOM.spinButton.disabled = true;
      }
    },
    
    updateShareButtons: function() {
      const userData = Storage.getUserData();
      const shareButtons = [
        DOM.facebookShare,
        DOM.twitterShare,
        DOM.whatsappShare,
        DOM.instagramShare,
        DOM.shareFb,
        DOM.shareTwitter,
        DOM.shareWhatsapp,
        DOM.shareInstagram
      ];
      
      shareButtons.forEach(button => {
        if (button) {
          button.disabled = userData.hasShared;
          button.title = userData.hasShared ? 'Already shared today' : button.title;
        }
      });
    },
    
    updateSpinsLeft: function() {
      const spinsLeftEl = document.getElementById('ev-spins-left');
      if (!spinsLeftEl) return;
      
      const userData = Storage.getUserData();
      const totalAvailable = CONFIG.dailyDrawLimit + (userData.extraSpins || 0);
      const usedToday = userData.drawsToday || 0;
      const remaining = Math.max(0, totalAvailable - usedToday);
      
      spinsLeftEl.textContent = remaining.toString();
    }
  };
  
  // 事件绑定
  const EventManager = {
    init: function() {
      this.bindSpinButton();
      this.bindEmailForm();
      this.bindShareButtons();
      this.bindSocialMediaButtons();
      this.bindUseButtons();
      this.bindShareTitle();
    },
    
    bindSpinButton: function() {
      if (!DOM.spinButton) return;
      
      DOM.spinButton.addEventListener('click', () => {
        SpinManager.handleSpin();
      });
    },
    
    bindEmailForm: function() {
      if (!DOM.emailForm || !DOM.emailSubmit || !DOM.emailInput) return;
      
      // 使用表单的submit事件，阻止默认行为
      DOM.emailForm.addEventListener('submit', (e) => {
        EmailManager.handleSubmit(e);
      });
      
      // 输入框回车提交
      DOM.emailInput.addEventListener('keypress', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          EmailManager.handleSubmit(e);
        }
      });
    },
    
    bindShareButtons: function() {
      // 主页面分享按钮
      const mainShareButtons = [
        { element: DOM.facebookShare, platform: 'facebook' },
        { element: DOM.twitterShare, platform: 'twitter' },
        { element: DOM.whatsappShare, platform: 'whatsapp' },
        { element: DOM.instagramShare, platform: 'instagram' }
      ];
      
      mainShareButtons.forEach(({ element, platform }) => {
        if (element) {
          element.addEventListener('click', () => {
            ShareManager.handleShare(platform);
          });
        }
      });
      
      // 分享弹窗内的按钮
      const popupShareButtons = [
        { element: DOM.shareFb, platform: 'facebook' },
        { element: DOM.shareTwitter, platform: 'twitter' },
        { element: DOM.shareWhatsapp, platform: 'whatsapp' },
        { element: DOM.shareInstagram, platform: 'instagram' }
      ];
      
      popupShareButtons.forEach(({ element, platform }) => {
        if (element) {
          element.addEventListener('click', () => {
            ShareManager.handleShare(platform);
          });
        }
      });
    },
    
    bindSocialMediaButtons: function() {
      // 分享标题点击打开分享弹窗
      if (DOM.shareTitle) {
        DOM.shareTitle.addEventListener('click', () => {
          Popup.open(DOM.sharePopup, DOM.shareOverlay);
        });
      }
    },
    
    bindUseButtons: function() {
      // 使用事件委托处理所有"Use"按钮
      document.addEventListener('click', (e) => {
        const button = e.target.closest('.ev-use-button');
        if (!button) return;
        
        e.preventDefault();
        
        // 防止重复点击
        if (button.disabled) return;
        
        if (button.dataset.variant) {
          CartManager.handleAddToCart(button.dataset.variant, button);
        } else if (button.dataset.code) {
          CartManager.handleDiscountCode(button.dataset.code, button);
        }
      });
    },
    
    bindShareTitle: function() {
      if (DOM.shareTitle) {
        DOM.shareTitle.addEventListener('click', () => {
          Popup.open(DOM.sharePopup, DOM.shareOverlay);
        });
      }
    }
  };
  
  // 图片预加载
  const ImagePreloader = {
    images: [],
    
    preload: function() {
      // 从配置中获取图片URL
      CONFIG.rewards.forEach(reward => {
        if (reward.image) {
          this.images.push(reward.image);
        }
      });
      
      this.images.forEach(src => {
        const img = new Image();
        img.src = src;
      });
    }
  };
  
  // 主初始化函数
  function init() {
    // 检查必要DOM元素
    if (!DOM.container) {
      console.error('Christmas Lucky Wheel container not found');
      return;
    }
    
    try {
      // 清除过期数据
      Storage.clearExpiredData();
      
      // 预加载图片
      ImagePreloader.preload();
      
      // 初始化各个模块
      Popup.bindCloseEvents();
      WinnersManager.init();
      PrizeManager.loadRewards();
      UI.update();
      EventManager.init();
      
      // 延迟更新次数显示
      setTimeout(() => UI.updateSpinsLeft(), 100);
      
      // 初始化完成
      console.log('Christmas Lucky Wheel initialized successfully');
      
      // 埋点：页面加载
      Analytics.track('page_loaded');
    } catch (error) {
      console.error('Christmas Lucky Wheel initialization error:', error);
      Message.showError('An error occurred while initializing the wheel. Please refresh the page.');
    }
  }
  
  // 页面加载完成后初始化
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  // 暴露全局API（可选）
  window.EVChristmasWheel = {
    init: init,
    spin: SpinManager.handleSpin.bind(SpinManager),
    showEmailPopup: () => Popup.open(DOM.emailPopup, DOM.emailOverlay),
    showSharePopup: () => Popup.open(DOM.sharePopup, DOM.shareOverlay),
    updateUI: UI.update.bind(UI)
  };
  
})();